<div class="container-xl">
  <h1 class="mt-6 mb-5">Activate Account</h1>
  <div class="row">
    <div class="col-xl-5 col-lg-5 col-md-8">
      <app-notifications [target]="'activate'" [extraCss]="'shadow'"></app-notifications>

      <form
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        enctype="application/x-www-form-urlencoded"
        method="post"
        role="form"
        autocomplete="off"
        novalidate
      >
        <div class="form-group mb-4">
          <label class="form-label">PIN Number</label>
          <input
            type="text"
            [ngClass]="{'form-control' : true, 'is-invalid' : formErrors['pin']}"
            formControlName="pin"
            required
            autofocus
          />
          <app-error-list [formErrors]="formErrors" [key]="'pin'"></app-error-list>
        </div>

        <div *ngIf="passwordRequired">
          <div class="form-group mb-4">
            <label class="form-label">New Password</label>
            <input
              type="password"
              [ngClass]="{'form-control' : true, 'is-invalid' : formErrors['password']}"
              formControlName="password"
              autocomplete="new-password"
            />
            <app-error-list [formErrors]="formErrors" [key]="'password'"></app-error-list>
          </div>

          <div class="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              [ngClass]="{'form-control' : true, 'is-invalid' : formErrors['confirmPassword']}"
              formControlName="confirmPassword"
              autocomplete="new-password"
            />
            <app-error-list [formErrors]="formErrors" [key]="'confirmPassword'"></app-error-list>
          </div>

          <input type="hidden" formControlName="recaptchaToken"  id="recaptchaToken" name="recaptchaToken"/>

        </div>

        <br/>
        <div class="g-recaptcha" [attr.data-sitekey]="siteKey" data-action="activate-account" data-callback="recaptcha_callback">
        </div>
        <br/>

        <div class="row">
          <div class="col-sm-8 col-md-8">
            <button #submitB type="submit" id="submit" class="btn btn-primary" [disabled]="!form.valid || isProcessing">
              <div *ngIf="isProcessing">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Processing ...
              </div>
              <span *ngIf="!isProcessing">Activate Account </span>
            </button>
          </div>
          <div class="col-sm-4 col-md-4">
            <a routerLink="/" class="btn btn-link btn-block mb-4">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
